import React, { useState } from 'react';
import { modals, quickbooksConfig as quickbooksConfigDuck } from '../../ducks';
import { currentUser, duckify } from '../../utils/duckify';
import { apiFetch } from '../../utils';
import FlashMessage from 'components/FlashMessage/FlashMessage';


const QuickbooksConfig = ({ allDucksReady, quickbooksConfig, dispatch, currentUser }) => {
  const [flashMessage, updateMessage] = useState('');
  const [data, updateData] = useState([]);

  const revokeAccess = () => {
    apiFetch.post({}, 'quickbooks_config/revoke_tokens')
      .then(() => {
          updateMessage('Access revoked');
          // rerender the component with the new config
          dispatch(quickbooksConfigDuck.actions.load());
        }
      );
  };

  const getData = (dataType) => {
    apiFetch.post({}, 'quickbooks_config/get_data', {data_type: dataType})
      .then((response) => {
        updateData(response[dataType]);
      })
      .catch((error) => dispatch(modals.actions.show('UnexpectedError')));
  };

  return <div>
    <h2>Quickbooks Integration</h2>
    {flashMessage && <FlashMessage message={flashMessage}/>}

    {allDucksReady &&
    <div> {quickbooksConfig.enabled ? <div>
        If the application has been uninstalled, click here to revoke access.
        <div><a className="btn btn-primary" onClick={revokeAccess}>Revoke Access</a></div>
      </div> :
      <div><a className="btn btn-primary" href={quickbooksConfig.link}>Install App</a></div>
    }</div>
    }

    {quickbooksConfig.enabled && currentUser.acl === 4 && <React.Fragment>
      <legend>Quickbooks Data Access (SuperAdmin Only)</legend>


      <p><a className="btn btn-primary" onClick={() => getData('Account')}>Get Accounts</a></p>
      <p><a className="btn btn-primary" onClick={() => getData('PaymentMethod')}>Get Payment Methods</a></p>

    </React.Fragment>}
    {data.length > 0 && <table className={'table table-striped'}>
      <thead>
      {[...new Set(data.map(i => Object.keys(i)).flat())]
        .map((header) => <th style={{ padding: '10px' }}>{header}</th>)}
      </thead>
      <tbody>
      {data.map((object) => {
        return <tr>{[...new Set(data.map(i => Object.keys(i)).flat())]
          .map((k) => <td>{JSON.stringify(object[k])}</td>)}</tr>;
      })}
      </tbody>
    </table>}

  </div>;
};

const mapDucksToProps = (props) => {
  return {
    currentUser,
    quickbooksConfig: quickbooksConfigDuck
  };
};

export default duckify(mapDucksToProps)(QuickbooksConfig);

